import { ComplainDetailView } from "@/components/dashboard/shared/pages/ComplaintsPage"
import { useAuthStore } from "@/store/auth.store"
import { useNavigate } from "@tanstack/react-router"

export function ComplaintDetailsPage({ complaintId }: { complaintId: string }) {
  const navigate = useNavigate()
  const currentUser = useAuthStore((s) => s.user)

  return (
    <ComplainDetailView
      id={complaintId}
      onBack={() => {
        navigate({
          to: "/complaints",
        })
      }}
      currentUser={currentUser}
      isAdmin={false}
      hideUser={true}
    />
  )
}
